<template>
  <div id="account">
    <div class="account-settings-container container">
      <h1 class="text-center my-5 brand-highlight-1">Account settings</h1>
      <template v-if="loading">
        <Loader />
      </template>

      <template v-else>
        <section class="section py-5 border-bottom border-top">
          <h2 class="">Email</h2>
          <span class="p-text-lg semi-bold">{{
            $store.getters.user.username
          }}</span>
          <b-button
            variant="cta"
            size="lg"
            @click="updateUserEmail()"
            squared
            class="ml-5"
            >Update</b-button
          >
          <div class="pt-5" v-if="$route.query.emailSuccess">
            <b class="p-text brand-highlight-1"
              >Your account's email address has been successfully updated!</b
            >
          </div>
        </section>
        <section class="section py-5 border-bottom">
          <h2 class="">Password</h2>
          <span class="p-text-sm semi-bold">
            <i class="fa-solid mr-1 fa-circle"></i>
            <i class="fa-solid mr-1 fa-circle"></i>
            <i class="fa-solid mr-1 fa-circle"></i>
            <i class="fa-solid mr-1 fa-circle"></i>
            <i class="fa-solid mr-1 fa-circle"></i>
            <i class="fa-solid mr-1 fa-circle"></i>
            <i class="fa-solid mr-1 fa-circle"></i>
          </span>
          <b-button
            variant="cta"
            size="lg"
            @click="updateUserPassword()"
            squared
            class="ml-5"
            >Update</b-button
          >
          <div class="pt-5" v-if="$route.query.passwordSuccess">
            <b class="p-text brand-highlight-1"
              >Your account's password has been successfully updated!</b
            >
          </div>
        </section>
        <section class="section py-5 border-bottom">
          <h2 class="">Date of Birth</h2>

          <div class="input-container">
            <b-form-input
              type="date"
              v-model="dobField"
              :disabled="!!dob"
              class="dob-input"
            />

            <b-button
              variant="cta"
              size="lg"
              @click="updateDob"
              squared
              class="update-button"
              v-if="!dob"
              >Update</b-button
            >
          </div>

          <p
            class="pt-3 api-status brand-highlight-1"
            v-if="dobApiUpdateSuccess"
          >
            {{ dobApiUpdateSuccess }}
          </p>

          <p class="pt-2 api-status error" v-if="dobApiUpdateError">
            {{ dobApiUpdateError }}
          </p>
        </section>
        <section class="section py-5 border-bottom">
          <h2 class="">Membership Number</h2>
          <div class="input-container">
            <b-form-input
              type="text"
              v-model="membershipNumberField"
              class="dob-input"
            />
            <b-button
              variant="cta"
              size="lg"
              @click="updateMembershipNumber"
              squared
              class="update-button"
              >Update</b-button
            >
          </div>
          <p
            class="pt-3 api-status brand-highlight-1"
            v-if="membershipNumberApiUpdateSuccess"
          >
            {{ membershipNumberApiUpdateSuccess }}
          </p>
          <p
            class="pt-2 api-status error"
            v-if="membershipNumberApiUpdateError"
          >
            {{ membershipNumberApiUpdateError }}
          </p>
        </section>
        <section class="section py-5 border-bottom" v-if="show_role_selection">
          <h2 class="">Job Role</h2>
          <div class="input-container">
            <b-form-select v-model="role" class="role-select">
              <b-form-select-option
                v-for="opt in user_role_options"
                :key="'opt' + opt.value"
                :value="opt.value"

                >{{ opt.option_text }}</b-form-select-option
              >
            </b-form-select>
            <b-button
              variant="cta"
              size="lg"
              @click="updateRole"
              squared
              class="update-button"
              :disabled="!role"
            >Update</b-button
            >
          </div>
          <p
            class="pt-3 api-status brand-highlight-1"
            v-if="roleApiUpdateSuccess"
          >
            {{ roleApiUpdateSuccess }}
          </p>
          <p
            class="pt-2 api-status error"
            v-if="roleApiUpdateError"
          >
            {{ roleApiUpdateError }}
          </p>
        </section>

        <p class="pt-2 api-status error" v-if="apiError">
          {{ apiError }}
        </p>
      </template>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import config from "../config/constants";
import Loader from "@/components/Loader.vue";

export default {
  name: "accountSettings",
  components: {
    Loader
  },
  data() {
    return {
      dob: "",
      dobField: "",
      membershipNumber: "",
      membershipNumberField: "",
      dobApiUpdateSuccess: "",
      dobApiUpdateError: "",
      membershipNumberApiUpdateSuccess: "",
      membershipNumberApiUpdateError: "",
      apiError: "",
      loading: false,
      role: null,
      user_role_options: [],
      roleApiUpdateSuccess: "",
      roleApiUpdateError: "",
      show_role_selection: false
    };
  },
  beforeCreate() {},
  mounted() {
    this.getAccountDetails();
  },
  methods: {
    async updateUserEmail() {
      await this.$msal.initialize();
      await this.$msal.loginRedirect({
        authority: process.env.VUE_APP_AXA_SSO_CHANGE_EMAIL_AUTHORITY,
        state: "changedEmail"
      });
    },
    async updateUserPassword() {
      await this.$msal.initialize();
      await this.$msal.loginRedirect({
        authority: process.env.VUE_APP_AXA_SSO_CHANGE_PW_AUTHORITY,
        state: "changedPassword"
      });
    },
    async updateDob() {
      this.dobApiUpdateSuccess = "";
      this.dobApiUpdateError = "";

      if (!this.validateAdultDob(this.dobField)) {
        this.dobApiUpdateError =
          "You must be at least 16 years old to use this service.";
        return;
      }

      try {
        const res = await axios.post(
          config.api_env + "/application/api/u/sapphire/users/set-dob",
          {
            user_id: this.$store.getters.user_id,
            dob: this.dobField
          },
          config.options
        );

        if (res.data.success) {
          this.dobApiUpdateSuccess =
            "Your date of birth has been successfully updated!";
          this.dobApiUpdateError = "";
          this.dob = this.dobField;
        } else {
          this.dobApiUpdateError =
            "An error occurred while updating your date of birth.";
        }
      } catch (e) {
        this.dobApiUpdateError =
          "An error occurred while updating your date of birth.";
      }
    },
    async updateMembershipNumber() {
      this.membershipNumberApiUpdateSuccess = "";
      this.membershipNumberApiUpdateError = "";

      const trimmedMembershipNumberField = this.membershipNumberField.trim();

      if (trimmedMembershipNumberField.length === 0) {
        this.membershipNumberApiUpdateError =
          "Please enter a valid membership number.";
        return;
      }

      try {
        const res = await axios.post(
          config.api_env +
            "/application/api/u/sapphire/users/set-axa-membership-number",
          {
            user_id: this.$store.getters.user_id,
            axa_membership_number: trimmedMembershipNumberField
          },
          config.options
        );

        if (res.data.success) {
          this.membershipNumberApiUpdateSuccess =
            "Your membership number has been successfully updated!";
          this.membershipNumberApiUpdateError = "";
          this.membershipNumber = this.membershipNumberField;
        } else {
          this.membershipNumberApiUpdateError =
            "An error occurred while updating your membership number.";
        }
      } catch (e) {
        this.membershipNumberApiUpdateError =
          "An error occurred while updating your membership number.";
      }
    },
    async updateRole() {
      this.roleApiUpdateSuccess = "";
      this.roleApiUpdateError = "";

      try {
        const res = await axios.post(
          config.api_env +
          "/application/api/u/sapphire/users/update-user-role",
          {
            user_id: this.$store.getters.user_id,
            value: this.role
          },
          config.options
        );

        if (res.data.success) {
          this.roleApiUpdateSuccess =
            "Your job role has been successfully updated!";
          this.roleApiUpdateError = "";
        } else {
          this.roleApiUpdateError =
            "An error occurred while updating your job role.";
        }
      } catch (e) {
        this.roleApiUpdateError =
          "An error occurred while updating your job role.";
      }
    },
    async getAccountDetails() {
      this.loading = true;
      try {
        const payload = { user_id: this.$store.getters.user_id };
        const res = await axios.post(
          config.api_env + "/application/api/u/sapphire/users/account",
          payload,
          config.options
        );
        if (res.data?.success) {
          this.dob = res.data.dob || "";
          this.dobField = res.data.dob || "";
          this.membershipNumber = res.data.axa_membership_number || "";
          this.membershipNumberField = res.data.axa_membership_number || "";
          this.apiError = "";
          this.role = res.data.role;
          this.user_role_options = res.data.user_role_options;
          this.show_role_selection = res.data.show_role_selection;
        } else {
          this.apiError =
            "An error occurred while loading your account details.";
        }
      } catch (e) {
        this.apiError = "An error occurred while loading your account details.";
      }
      this.loading = false;
    }
  },
  computed: {
    filteredFaqs() {
      return this.faqs.filter(faq => {
        return (
          faq.question.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
          faq.answer.toLowerCase().includes(this.searchQuery.toLowerCase())
        );
      });
    },
    componentText() {
      return this.getText.loggedIn.faqs;
    }
  }
};
</script>
<style lang="less">
#account {
  .updated-color {
    color: #66ff00;
  }

  .input-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;

    @media only screen and (max-width: 576px) {
      flex-direction: column;
      align-items: flex-start;
    }
  }

  .dob-input {
    padding: 15px;
    border: 1px solid #757575;
    border-radius: 8px;
    font-size: 1.8rem;
    min-height: 50px;
    max-width: 300px;

    @media only screen and (max-width: 576px) {
      margin-bottom: 20px;
    }
  }

  .role-select {
    padding: 5px 15px;
    border: 1px solid #757575;
    border-radius: 8px;
    font-size: 1.8rem;
    min-height: 50px;
    max-width: 300px;

    @media only screen and (max-width: 576px) {
      margin-bottom: 20px;
    }
  }

  .update-button {
    margin-left: 10px;

    @media only screen and (max-width: 576px) {
      margin-left: 0 !important;
    }
  }

  .api-status {
    font-size: 1.6rem;

    &.error {
      color: #c91432;
    }
  }
}
</style>
